module.exports = __webpack_public_path__ + "static/img-news-video-52cf5e11294cca26786bad859a6cbff0.jpg";